export const header = {
	init: function(header) {
		if (!header) return;
		this.mobileBtn = header.querySelectorAll('[data-open]');
		this.mobileMenuFirstLevel =  header.querySelector('[data-content="level1"]');
		this.submenuContents = header.querySelectorAll('[data-content]');
		this.mobileBtnClose = header.querySelectorAll('[data-mobile="btn-close"]');
		this.backBtn = header.querySelectorAll('[data-back]');
		this.body = document.querySelector('body');
		this.openClassMobile = 'jsOpenMobile';
		this.openClassDesktop = 'jsOpenDesktop';
		this.currentBtn;
		this.assignEventListeners();

		[].slice.call(this.submenuContents).forEach(function(submenu) {
			submenu.addEventListener('click', function(e) {
				e.stopPropagation();
			});
		});
	},
	assignEventListeners: function() {
		[].slice.call(this.mobileBtn).forEach((btn)=> {
			btn.addEventListener('click', (e)=> {
				if (window.innerWidth < 1024) {
					this.mobileMenuOpen(btn);
				} else {
					this.dekstopMenuOpen(e, btn);
				}
			});
		});

		[].slice.call(this.mobileBtnClose).forEach((btn)=> {
			btn.addEventListener('click', _=> {
				this.mobileMenuClose();
			});
		});

		[].slice.call(this.backBtn).forEach((key)=> {
			key.addEventListener('click', _=> {
				this.mobileMenuBack(key);
			});
		});

		this.body.addEventListener('click', (e)=> {
			[].slice.call(this.submenuContents).forEach((submenu)=> {
				this.removeClass(submenu, 'noTransition');
			});
			this.removeClass(this.body, 'open');
			this.desktopMenuCollapse();
		})

	},
	dekstopMenuOpen: function(e, btn) {
		e.preventDefault();
		e.stopPropagation();

		if (this.currentBtn !== btn && this.body.classList.contains('open')) {
			[].slice.call(this.submenuContents).forEach((submenu)=> {
				this.addClass(submenu, 'noTransition');
			});
		} else {
			[].slice.call(this.submenuContents).forEach((submenu)=> {
				this.removeClass(submenu, 'noTransition');
			});
			this.removeClass(this.body, 'open');
		}
		this.currentBtn = btn;

		if (!btn.classList.contains('header__title--open')) {
			this.addClass(this.body, 'open');
			this.desktopMenuCollapse();
			this.addClass(btn, 'header__title--open');
			this.addClass(btn.nextElementSibling, this.openClassDesktop);
		} else {
			this.desktopMenuCollapse();
		}
	},
	desktopMenuCollapse: function() {
		[].slice.call(this.submenuContents).forEach((key)=> {
			this.removeClass(key, this.openClassDesktop);
		});

		[].slice.call(this.mobileBtn).forEach((key)=> {
			this.removeClass(key, 'header__title--open');
		});
	},
	mobileMenuOpen: function(btn) {
		const dataOpen = btn.dataset.open;
		this.addClass(this.body, "mobileMenuOpen");

		[].slice.call(this.submenuContents).forEach((key)=> {
			if (dataOpen === key.dataset.content) {
				key.classList.add(this.openClassMobile);
			}
		});
	},
	mobileMenuClose: function() {
		this.removeClass(this.body, "mobileMenuOpen");
		[].slice.call(this.submenuContents).forEach((key)=> {
			this.removeClass(key, this.openClassMobile);
		});
	},
	mobileMenuBack: function(btn) {
		const dataBack = btn.dataset.back;
		[].slice.call(this.submenuContents).forEach((key)=> {
			if (key.dataset.content === dataBack) {
				this.removeClass(key, this.openClassMobile);
				this.addClass(key, "heightTransition");
				setTimeout(() => {
					this.removeClass(key, "heightTransition");
				}, 500);
			}
		});
	},
	removeClass: function(el, className) {
		el.classList.remove(className);
	},
	addClass: function(el, className) {
		el.classList.add(className);
	}
}
